export enum MoveTrackerStatusType {    
    Pickup = 10,
    FlightLeg1 = 20,
    FlightLeg2 = 30,
    Recovery = 40,
    Delivery = 50
}